import Immutable from 'immutable';

const initialState = Immutable.Map();

function loadCurrenciesStarted(state, _payload) {
  return state.set('loading', true);
}

function loadCurrenciesCompleted(state, payload) {
  state.set('loading', false);
  return state.set('options', Immutable.fromJS(payload));
}

function loadCurrenciesFailed(state, payload) {
  state.set('loading', false);
  return state.set('errors', payload);
}

export default function reducer(state = initialState, { type, payload }) {
  return state.withMutations((state) => {
    return (
      {
        CURRENCIES_LOAD: loadCurrenciesStarted,
        CURRENCIES_LOAD_COMPLETED: loadCurrenciesCompleted,
        CURRENCIES_LOAD_FAILED: loadCurrenciesFailed,
      }[type] || (() => state)
    )(state, payload);
  });
}
